"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amIFollowingWatch = exports.getUserDataWatch = exports.userReviewWatchers = void 0;
var effects_1 = require("redux-saga/effects");
var actions = __importStar(require("./userReviewActions"));
var api = __importStar(require("./userReviewApi"));
exports.userReviewWatchers = [getUserDataWatch, amIFollowingWatch];
function getUserDataWatch() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.getUserData.TRIGGER, getUserData)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.getUserDataWatch = getUserDataWatch;
function amIFollowingWatch() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(actions.amIFollowing.TRIGGER, amIFollowing)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.amIFollowingWatch = amIFollowingWatch;
function getUserData(_a) {
    var results, _b, _c, _d, _e;
    var payload = _a.payload;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (!payload.userId) return [3 /*break*/, 4];
                _c = effects_1.all;
                return [4 /*yield*/, api.getUserData(payload)];
            case 1:
                _d = [
                    _f.sent()
                ];
                return [4 /*yield*/, api.amIFollowing(payload.userId, payload.id)];
            case 2: return [4 /*yield*/, _c.apply(void 0, [_d.concat([
                        _f.sent()
                    ])])];
            case 3:
                _b = _f.sent();
                return [3 /*break*/, 7];
            case 4:
                _e = effects_1.all;
                return [4 /*yield*/, api.getUserData(payload)];
            case 5: return [4 /*yield*/, _e.apply(void 0, [[
                        _f.sent()
                    ]])];
            case 6:
                _b = _f.sent();
                _f.label = 7;
            case 7:
                results = _b;
                if (!(results[0].status == 200)) return [3 /*break*/, 9];
                results[0].data.amIFollowing = results[1] || false;
                return [4 /*yield*/, (0, effects_1.put)(actions.getUserData.success(results[0].data))];
            case 8:
                _f.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)(actions.getUserData.failure(results[0]))];
            case 10:
                _f.sent();
                _f.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}
function amIFollowing(_a) {
    var serverResponse;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, api.amIFollowing(payload.userId, payload.id)];
            case 1:
                serverResponse = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(actions.amIFollowing.success(serverResponse))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
